// extracted by mini-css-extract-plugin
export default {"title":"details-controller_title__Y+kF4","series":"details-controller_series__M4nWu"};